import ScriptWorkspace from '../common/ScriptWorkspace';

export default function CorporateScriptDetail() {
  return (
    <ScriptWorkspace scriptsIndexPath="/brand/scripts" breadcrumbScriptsLabel="Scripts" />
  );
}
